import { Interactions } from 'os-elements';
import SelectFeature from './SelectFeature/SelectFeature';
import DrawAndModify from './DrawAndModify/DrawAndModify';

const MapInteractions = () => {
    return (
        <Interactions>
            <DrawAndModify/>
            <SelectFeature/>
        </Interactions>

    );
};

export default MapInteractions;
